import React from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useRegisterContext } from "../../context/ContextProvider";
import "./spend.scss";
import {
	SpendStep1,
	SpendStep2,
	SpendStep3,
	SpendStep4,
	Success,
	Steps,
} from "../../components/steps";

const Spend = () => {
	const { activeStyle } = useRegisterContext();

	return (
		<section className="spend__container">
			<div className="container spend__container-div">
				<div className="top">
					{activeStyle === 1 && (
						<Link to="/">
							<span>
								<AiOutlineArrowLeft />
							</span>
						</Link>
					)}
					<div className="steps__container">
						<Steps isEnding={false} length={4} />
					</div>
				</div>
				<div className="bottom">
					{/* check context to apply active style */}
					{activeStyle === 1 && (
						<SpendStep1 text="What type of Building are you calculating for?" />
					)}
					{activeStyle === 2 && (
						<SpendStep2 text="Tell us the State and City the Bulding is located" />
					)}
					{activeStyle === 3 && <SpendStep3 />}
					{activeStyle === 4 && (
						<SpendStep4
							title="Unit comsumed / month"
							subtitle="1356.67"
							brSubtitle="UNIT"
						/>
					)}
					{activeStyle === 5 && <Success />}
				</div>
			</div>
		</section>
	);
};

export default Spend;
